function cov_1iz2md7fip() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SearchFilled.tsx";
  var hash = "b9eebb82d972300528f7976a68822a62a6726b10";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SearchFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b9eebb82d972300528f7976a68822a62a6726b10"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1iz2md7fip = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1iz2md7fip();
var Icon = (cov_1iz2md7fip().s[0]++, {
  name: 'search-filled',
  svg: "<path d=\"M10 14C12.2091 14 14 12.2091 14 10C14 7.79086 12.2091 6 10 6C7.79086 6 6 7.79086 6 10C6 12.2091 7.79086 14 10 14Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 18C11.6983 18 13.273 17.4708 14.5682 16.5683L20 22.0001C20.4882 22.4882 21.2796 22.4882 21.7678 22.0001C22.2559 21.5119 22.2559 20.7205 21.7678 20.2323L16.3726 14.8371C17.3938 13.4937 18 11.8177 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 15.5C13.0376 15.5 15.5 13.0376 15.5 10C15.5 6.96243 13.0376 4.5 10 4.5C6.96243 4.5 4.5 6.96243 4.5 10C4.5 13.0376 6.96243 15.5 10 15.5Z\" fill=\"currentColor\"/>"
});
export default Icon;